import {
  Button,
  ButtonProps,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SubmitChangesButtonWithConfirmation: React.FC<
  { onConfirmedSubmit: (e: React.MouseEvent) => void } & ButtonProps
> = ({ onConfirmedSubmit, ...buttonProps }) => {
  const { t } = useTranslation(['payout', 'document']);
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button alignSelf={'center'} onClick={onOpen} {...buttonProps}>
        {t('document:button.AnderungenEinreichen')}
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading size={'xl'}>
              {t(
                'payout:headline.MochtestDuDeineAnderungenZurUberprufungEinreichen'
              )}
            </Heading>
          </ModalHeader>
          <ModalBody>
            <Text>
              {t(
                'payout:text.WennDuFortfahrstStartetEinUberprufungsprozessDerEtwasZeitInAnspruchNXX'
              )}
            </Text>
            <Text>
              {t(
                'payout:text.DeineAltenAngabenBleibenErhaltenSolangeDeineAnderungenNichtAkzeptierXX'
              )}
            </Text>
          </ModalBody>
          <ModalFooter justifyContent={'center'}>
            <VStack alignItems={'stretch'}>
              <Button
                onClick={(e) => {
                  onClose();
                  onConfirmedSubmit(e);
                }}
              >
                {t('payout:button.SpeichernEinreichen')}
              </Button>
              <Button variant={'outline'} onClick={onClose} flexShrink={1}>
                {t('payout:button.AnderungenNochEinmalKontrollieren')}
              </Button>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
